"use client";

import * as styles from "./styles.css";
import PageSection from "@/components/page-section";
import ContentContainer from "@/components/content-container";
import { useEffect, useState } from "react";
import Link from "next/link";
import SocialMediaIcons from "@/elements/social-media-icons";

interface SocialProps {
  title: string;
}

export default function ArticleSocial(props: SocialProps) {
  const [socialMedia, setSocialMedia] = useState<any[]>([]);

  useEffect(() => {
    const location = encodeURI(window.location.href);

    setSocialMedia([
      {
        type: "facebook",
        url: `https://www.addtoany.com/add_to/facebook?linkurl=${location}&amp;linkname=${props.title}`,
      },
      {
        type: "linkedin",
        url: `https://www.addtoany.com/add_to/linkedin?linkurl=${location}&amp;linkname=${props.title}`,
      },
      {
        type: "email",
        url: `https://www.addtoany.com/add_to/email?linkurl=${location}&amp;linkname=${props.title}`,
      },
    ]);
  }, [setSocialMedia, props.title]);

  return (
    <PageSection layout="social">
      <ContentContainer layout="social">
        <div
          className={`${styles.container} content--narrow is--module is--article module--social`}
        >
          <div className={styles.headingContainer}>Share this article</div>
          <div className={styles.socialContainer}>
            {socialMedia.map((item) => (
              <Link
                key={item.type}
                href={item?.url ?? "/"}
                target="_blank"
                prefetch={false}
              >
                <div className="icon__container">
                  <SocialMediaIcons socialMedia={item.type} />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </ContentContainer>
    </PageSection>
  );
}
